import * as React from "react";
const SvgFile = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 18.5V9H13V5.5H7.5V18.5H16.5ZM7.5 4H14L18 8V18.5V20H16.5H7.5H6V18.5V5.5V4H7.5Z", fill: "currentColor" }));
export default SvgFile;
